import {
  EntityTerminationStage,
  EntityTerminationUriSegment,
  IEntityTerminationStagePivotItem,
} from './types';

const entityTerminationPivotItems: IEntityTerminationStagePivotItem[] = [
  {
    itemKey: EntityTerminationStage.ELIGIBILITY_REVIEW,
    urlSegment: EntityTerminationUriSegment.EligibilityReview,
  },
  {
    itemKey: EntityTerminationStage.BLOCKER,
    urlSegment: EntityTerminationUriSegment.Blocker,
  },
  {
    itemKey: EntityTerminationStage.ELIGIBLE,
    urlSegment: EntityTerminationUriSegment.Overview,
  },
  {
    itemKey: EntityTerminationStage.LEGAL_IN_PROCESS,
    urlSegment: EntityTerminationUriSegment.LegalInProcess,
  },
  {
    itemKey: EntityTerminationStage.FINANCE_INCOMPLETE,
    urlSegment: EntityTerminationUriSegment.FinanceIncomplete,
  },
  {
    itemKey: 'All',
    urlSegment: EntityTerminationUriSegment.Overview,
  },
];

export default entityTerminationPivotItems;
